module.exports = __webpack_public_path__ + "static/media/Pixel3.png?v=c40ec46d";